<template>
<div class="popup" v-cloak v-if="appNowPaySchemeShow">
    <div class="content" id="appNowPayScheme">
        <div class="title">
              {{$t('language.popup.upgradeAccountPopup.currentPlan')}}
            <div class="icon white-close dialog-close" @click="appNowPaySchemeShow=false"></div>
        </div>
        <div class="app-now-scheme-body">
            <div class="app-now-scheme-mid">
                <div v-show="payInfo.type=='ios'">
                    <div class="app-now-scheme-tips">{{$t('language.paySystem.nowPayScheme.appleTip',{"name":payInfo.name})}}</div>
                    <div class="app-now-scheme-tips">{{$t('language.paySystem.nowPayScheme.appleTipId',{"id":payInfo.transactionId})}}</div>
                </div>
                <div v-show="payInfo.type=='google'">
                    <div class="app-now-scheme-tips">{{$t('language.paySystem.nowPayScheme.googleTip',{"name":payInfo.name})}}</div>
                    <div class="app-now-scheme-tips">{{$t('language.paySystem.nowPayScheme.googleTipId',{"id":payInfo.transactionId})}}</div>
                </div>
            </div>
            <div class="app-now-scheme-mid">
                <div class="app-now-scheme-tips">
                    <span v-if="payInfo.isSubscribe">{{$t('language.paySystem.nowPayScheme.appNextTimeTip',{"time":payInfo.nextTime})}}</span>
                    <span v-if="!payInfo.isSubscribe">{{$t('language.paySystem.nowPayScheme.appNoSubscribe')}}</span>
                </div>
            </div>
            <div class="app-now-scheme-close">
                <button style="border-radius: 5Px;" @click="appNowPaySchemeShow=false">{{$t('language.common.ok')}}</button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data() {
        return {
            appNowPaySchemeShow: false,
            user: commonUtils.getUser(),
            payInfo: {
                name: "",
                transactionId: "",
                type: "",//订阅类型：ios,google
                isSubscribe: true,//是否订阅
                nextTime: "",
            },
        }
    },
    methods: {
    }
}
</script>

<style>
#appNowPayScheme {
    width: 650px;
    /*no*/
    height: 210px;
    /*no*/
}

.app-now-scheme-body{
    padding: 20Px;
    display: grid;
}

.app-now-scheme-msg{
    display: flex;
    margin-bottom: 10Px;
}

.app-now-scheme-msg-left{
    width: 60%;
    float: left;
    display: grid;
}

.app-now-scheme-msg-right{
    width: 40%;
    float: right;
    display: grid;
    text-align: right;
    padding-right: 20Px;
}

.app-now-scheme-name{
    color: #333333;
    font-size: 16Px;
    font-weight: 700;
    line-height: 20Px;
}

.app-now-scheme-tip{
    color: #6f6f6f;
    font-size: 14Px;
    line-height: 22Px;
}

.app-now-scheme-price{
    line-height: 33Px;
}

.app-now-scheme-price .price{
    font-size: 30Px;
    color: #5562b4;
}

.app-now-scheme-price .old-price{
    color: #b8bee6;
    position: unset;
    float: unset;
}

.app-now-scheme-vat{
    font-size: 14Px;
    color: #a3adbd;
    line-height: 20Px;
}

.app-now-scheme-mid {
    display: grid;
    line-height: 22Px;
    font-size: 14Px;
    margin: 3Px 0;
}

.app-now-scheme-mid .app-now-scheme-tips{
    color: #333333;
}

.app-now-scheme-mid .app-now-scheme-click span{
    color: #5562b4;
    cursor: pointer;
}

.app-now-scheme-mid .app-now-scheme-click span:hover{
    text-decoration: underline;
}

.app-now-scheme-close{
    position: absolute;
    bottom: 20Px;
    right: 20Px;
}

.app-now-scheme-close button{
    width: 110Px;
    height: 30Px;
    background: linear-gradient(to right,#6576df, #8580e7);
}

#nowPayScheme .title{
    background: linear-gradient(to right,#6576df, #8480da);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/app_now_pay_scheme_popups.vue